import Box from '@mui/material/Box'
import { blueGrey } from '@mui/material/colors'
import FarmSelector from '../FarmSelector/FarmSelector'
import VersionLabel from './VersionLabel'

const HomePage = () => {
  return (
    <Box
      sx={{
        height: '100%',
        minHeight: 0,
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        // auto, not hidden: below the table's minimum height this area scrolls instead of clipping rows.
        overflow: 'auto',
        backgroundColor: blueGrey[50],
      }}
    >
      <FarmSelector />
      <VersionLabel />
    </Box>
  )
}

export default HomePage
